import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./alert.scss";

interface MyAlertProps {
  children?: React.ReactNode;
  title?: string | React.ReactNode;
  content: string | React.ReactNode;
  success?: boolean;
  customCls?: string;
  index?: number;
}

interface MyAlertComponentProps extends MyAlertProps {
  parentId: string;
}

const MyAlert: React.FC<MyAlertComponentProps> = ({
  children,
  title,
  content,
  success,
  parentId,
  index,
  customCls,
}) => {
  const [showAlert, setShowAlert] = useState(true);

  const handleClose = () => {
    setShowAlert(false);
    ReactDOM.unmountComponentAtNode(document.getElementById(parentId)!!);
    // document.body.removeChild(document.getElementById(parentId)!!);
  };

  if (showAlert) {
    let inner = children;
    if (!inner) {
      const defaultTitle = success ? "Operation Success" : "Operation Failed";
      inner = (
        <div className="alert-content-1">
          <div className="alert-content--title">{title || defaultTitle}</div>
          <div className="alert-content--content">{content}</div>
        </div>
      );
    }

    return ReactDOM.createPortal(
      <div
        className={`${customCls || ""} global-alert-container`}
        style={{ zIndex: index }}
        id={parentId}
      >
        <div className="global-alert-content">
          <div className="global-alert--close" onClick={handleClose}></div>
          {inner}
        </div>
      </div>,
      document.body
    );
  }

  return null;
};

let order = 0;
export const showAlert = (props: MyAlertProps) => {
  return (() => {
    const container = document.createElement("div");
    const parentId = "alert--" + Date.now() + "-" + Math.random();
    container.id = parentId;
    order++;
    document.body.appendChild(container);

    const alert = (
      <MyAlert
        {...{ parentId: parentId, index: 100000 + order, ...props }}
      ></MyAlert>
    );

    const ret = {
      hide: () => {
        setTimeout(() => {
          ReactDOM.unmountComponentAtNode(container);
        }, 0);
      },
    };

    ReactDOM.render(alert, container);

    return ret;
  })();
};

export default showAlert;
